import classNames from "classnames"
import React, { useState } from "react"
import { Drawer } from "vaul"

import { PayflexLogo } from "./PayflexLogo"
import { PayflexModal } from "./PayflexModal"
import { Color } from "../../../../../constants/V2/color"
import { formatPrice } from "../../../../../utils/price"
import TextButton from "../../../../elements/V2/Buttons/TextButton"
import Typography from "../../../../elements/V2/Typography"

interface PayflexSectionProps {
  price: number
  color?: Color
  iconOnly?: boolean
  className?: string
  textSectionClassName?: string
  learnMoreColor?: Color
}

export const PayflexSection = ({
  price,
  color = Color.Black,
  iconOnly = false,
  className,
  textSectionClassName,
  learnMoreColor = Color.PayflexPurple,
}: PayflexSectionProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Drawer.Root
      open={isModalOpen}
      direction="bottom"
      onOpenChange={() => setIsModalOpen(false)}
    >
      <PayflexModal />
      <div
        className={classNames("flex items-center gap-10 sm:gap-20", className)}
      >
        <PayflexLogo iconOnly={iconOnly} />
        <div className={textSectionClassName}>
          <Typography
            font="grotesk"
            size="body-sm"
            weight="book"
            text="Or split into 4x"
            color={color}
            element="span"
          />{" "}
          <Typography
            font="grotesk"
            size="body-sm"
            weight="medium"
            text="interest-free"
            color={color}
            element="span"
          />{" "}
          <Typography
            font="grotesk"
            size="body-sm"
            weight="book"
            text="payments of"
            color={color}
            element="span"
          />{" "}
          <Typography
            font="grotesk"
            size="body-sm"
            weight="medium"
            text={formatPrice(price / 4)}
            color={color}
            element="span"
          />{" "}
          <Typography
            font="grotesk"
            size="body-sm"
            weight="book"
            text="over 6 weeks"
            color={color}
            element="span"
          />{" "}
          <TextButton
            style="underlined"
            text="Learn More"
            color={learnMoreColor}
            textSize="body-sm"
            onClick={() => setIsModalOpen(true)}
          />
        </div>
      </div>
    </Drawer.Root>
  )
}
